// extracted by mini-css-extract-plugin
export default {"buttons":"stw_633Q8krZpPjBT1lV__buttons___"};